//const iconStyle = { position: 'absolute', right: 0, top: "50%", transform: "translateY(-50%)" };
const DateIcon = (props) => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="17.818" height="14.5" viewBox="0 0 17.818 14.5">
  <defs>
    {/* <style>
      .cls-1 {
        fill: '#fff',
        stroke: '#14a4c2'
      },

      .cls-2, .cls-4 {
        fill: none,
      },

      .cls-2 {
        stroke: '#ffa539'
        stroke-linecap: 'round'
      },

      .cls-3 {
        stroke:' none'
      }
    </style> */}
  </defs>
  <g id="Calendar_Icon" dataname="Calendar Icon" transform="translate(0 0.5)">
    <g id="Calender_Icon" dataname="Calender Icon">
      <g id="Rectangle_122" dataname="Rectangle 122" className="cls-1" transform="translate(0 0.824)">
        <rect className="cls-3" width="17.818" height="13.176" rx="2"/>
        <rect className="cls-4" x="0.5" y="0.5" width="16.818" height="12.176" rx="1.5"/>
      </g>
      <g id="Group_132" dataname="Group 132" transform="translate(4.455)">
        <line id="Line_102" dataname="Line 102" className="cls-2" y2="4.148"/>
        <line id="Line_103" dataname="Line 103" className="cls-2" y2="4.148" transform="translate(8.909)"/>
      </g>
    </g>
  </g>
</svg>
    )
};

export default DateIcon